import { useEffect, useRef, useState } from 'react'
import {
  Box, Button, Checkbox, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper,
} from '@mui/material'
import { useDispatch } from 'react-redux'
import FilterAltOutlinedIcon from '../../images/filter.svg'
import { ReactComponent as CheckBorder } from '../../images/checkBorder.svg'
import { ReactComponent as CheckedIcon } from '../../images/checkedIcon.svg'
import { objNotEmpty } from '../../utils/helpers';

const FilterBy = ({
  store,
  actionToDispatch,
  actionProps,
  customStyle,
}) => {
  const dispatch = useDispatch()
  const [popperStatus, setPopperStatus] = useState(false)
  const anchorRef = useRef(null)
  const prevOpen = useRef(popperStatus)

  const handleFilterBy = (value) => {
    if (objNotEmpty(actionProps)) {
      dispatch(actionToDispatch({ queries: { filterBy: value, ...actionProps } }))
    } else {
      dispatch(actionToDispatch({ queries: value }))
    }
    handleClose()
  }

  const handleToggle = () => {
    setPopperStatus(!popperStatus)
  }

  const handleClose = () => {
    setPopperStatus(false)
  }

  useEffect(() => {
    if (prevOpen.current === true && popperStatus === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = popperStatus
  }, [popperStatus])

  return (
    <Box sx={[styles.changeStatusContainer, customStyle && customStyle]}>
      <Button
        ref={anchorRef}
        aria-controls={popperStatus ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        sx={styles.moreActionsButton}
        onClick={handleToggle}
      >
        <img src={FilterAltOutlinedIcon} alt="" />
      </Button>

      <Popper
        open={popperStatus}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        sx={styles.changeStatusPopper}
      >
        {({
          TransitionProps,
          placement,
        }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper sx={styles.popperPaper} onClick={handleClose}>
              <ClickAwayListener onClickAway={handleClose}>
                <Box sx={styles.paperContainer}>
                  <MenuList>
                    {store.filterList?.map((singleFilter) => (
                      <MenuItem
                        key={singleFilter.id}
                        onClick={() => handleFilterBy(singleFilter)}
                        sx={styles.menuItem}
                      >
                        <Checkbox
                          sx={styles.checkbox}
                          icon={<CheckBorder />}
                          checkedIcon={(
                            <CheckedIcon
                              style={styles.checkedIcon}
                            />
                          )}
                          checked={store?.activeFilters
                            ?.find((current) => current?.id === singleFilter?.id)}
                        />
                        {singleFilter.name}
                      </MenuItem>
                    ))}
                  </MenuList>
                </Box>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  )
}

const styles = {
  changeStatusContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '15px',
  },
  moreActionsButton: {
    height: { xs: '35px', sm: '40px' },
    minWidth: { xs: '35px', sm: '40px' },
    borderRadius: '12px',
    border: '1px solid #e2e8ee',
    backgroundColor: 'white',
    color: 'text.hint',
    overflow: 'hidden',
    padding: '0',

  },
  changeStatusPopper: {
    minWidth: { xs: '150px', sm: '200px' },
    zIndex: '9',
  },
  popperPaper: {
    borderRadius: '12px',
  },
  paperContainer: {
    padding: '10px 15px',
    maxHeight: '288px',
    overflowY: 'scroll',
    '::-webkit-scrollbar': {
      width: '0.3em',
    },
    '::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'primary.main',
      minHeight: '1em',
    },
  },
  checkbox: {
    '& .MuiCheckbox-colorPrimary': {
      color: '#E2E8EE',
    },
    '& .Mui-checked': {
      color: '#E2E8EE',
    },
  },
  checkedIcon: {
    width: '20px',
    height: '20px',
  },
  menuItem: {
    padding: '0px',
    '&:hover': { backgroundColor: 'transparent' },
    fontSize: '14px',
    fontWeight: '500',
  },
}

export default FilterBy
